import {createApp} from 'vue'
import App from './App.vue'
import axios from 'axios'

//globals
import InlineSvg from 'vue-inline-svg'

//state
import {store} from './store'

//routes
import VueGtag from "vue-gtag-next"
import router from './router'

//templates
import Generic from "@/components/pages/Generic"
import Home from "@/components/pages/Home"
import Project from "@/components/pages/Project"
import Careers from "@/components/pages/Careers"
import About from "@/components/pages/About"
import Work from "@/components/pages/Work"
import Search from "@/components/pages/Search"
import Archive from "@/components/pages/Archive"

//GLOBAL CONFIG
let craftApiPreviewToken = ''
if (window.siteConfig?.xCraftLivePreview) {
    // do not start with ? or &
    craftApiPreviewToken = 'tokenParam=' + window.siteConfig?.xCraftLivePreview + '&token=' + window.siteConfig?.xCraftLivePreviewToken
}
window.config = {
    metaTitleAddon: "ARSONAL",
    loadedOnce: false,
    routerInTransition: false,
    apiroot: process.env.VUE_APP_API,
    apirootActions: process.env.VUE_APP_API_ACTIONS,
    craftApiPreviewToken: craftApiPreviewToken,
    //skipPreview: (process.env.VUE_APP_API === 'https://arsonal.ddev.site/feed/' || window.siteConfig?.xCraftLivePreview),
    skipPreview: (window.siteConfig?.xCraftLivePreview),
    json: {
        global: null
    },
}
axios.get((`${window.config.apiroot}global/?${craftApiPreviewToken}`))
    .then((res) => {
        //GLOBAL CONFIG
        window.config.json.global = res.data

        //DYNAMIC ROUTES
        for (let i = 0; i < res.data.routes.length; i++) {
            let obj = res.data.routes[i]
            let newobj = {
                path: obj.path,
                meta: {
                    title: obj.title,
                    type: obj.type,
                },
            }
            switch (obj.type) {
                case 'home':
                    newobj.component = Home
                    break
                case 'generic':
                    newobj.component = Generic
                    break
                case 'project':
                    newobj.component = Project
                    break
                case 'careers':
                    newobj.component = Careers
                    break
                case 'about':
                    newobj.component = About
                    break
                case 'work':
                    newobj.component = Work
                    break
                case 'search':
                    newobj.component = Search
                    break
                case 'archive':
                    newobj.component = Archive
                    break
            }
            router.addRoute(newobj)
        }

        //page not found
        let newobj = {
            name: 'page-not-found',
            path: "/:catchAll(.*)",
            component: Generic,
            meta: {
                title: 'Page Not Found',
                type: 'generic'
            }
        }
        router.addRoute(newobj)

        //START APP
        startApp()
    }).catch(() => {
})

function startApp () {
    //LOAD
    const app = createApp(App)
    app.use(router)
    app.use(store)


    //ANALYTICS - in your main.js, below loading your router
    if (window.location.hostname !== "localhost") {
        app.use(VueGtag, {
            property: {
                id: window.config.json.global.config.googleAnalyticsId
            }
        })
    }

    // global inline svg
    app.component('inline-svg', InlineSvg)

    app.mount('#app')
}
